import { render, staticRenderFns } from "./insuranceFeeDetail.vue?vue&type=template&id=bd317468&scoped=true&"
import script from "./insuranceFeeDetail.vue?vue&type=script&lang=js&"
export * from "./insuranceFeeDetail.vue?vue&type=script&lang=js&"
import style0 from "./insuranceFeeDetail.vue?vue&type=style&index=0&id=bd317468&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd317468",
  null
  
)

export default component.exports